// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"8":"editor","36":"redirect_form","538":"editor_dev_login","818":"client"}[chunkId] || chunkId) + "." + {"8":"53de23f7","36":"2c0b8c80","47":"12f64e1c","73":"1c791438","398":"21890b32","421":"98adab06","538":"52828987","561":"bf4b5f65","818":"0ca72f01","820":"373207b0"}[chunkId] + ".chunk.js";
};